import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
})
export class CustomModalComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('templateModal', { read: TemplateRef, static: true })
  public templateModal: TemplateRef<any>;

  @Input() public isShowHeader: boolean = true;
  @Input() public isOpenOrCloseOnInit: boolean = false;
  @Input() public open: boolean = false;
  @Input() public header: any;
  @Input() public headerPrefix: any;
  @Input() public type: 'error' | 'default' | 'warning' = 'default';
  @Input() public modalClass: string = '';
  @Input() public size: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() public modalInnerBodyClass: string = 'p-3';
  @Input() public isAlert: boolean = false;
  @Input() public isWithOverflow: boolean = true;
  @Input() public isListenClose: boolean;
  @Input() public isShowCustomHeader: boolean = false;
  @Input() public isShowTopDecorationLine: boolean = false;
  @Input() public iconPath: string;

  @Output() public openChange: EventEmitter<any> = new EventEmitter();
  @Output() public closeClick: EventEmitter<any> = new EventEmitter();

  private modalRef: BsModalRef;
  private isDestroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private modalService: BsModalService, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.isOpenOrCloseOnInit) {
      if (this.open) {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const openPreviousValue = changes.open && changes.open.previousValue;
    const currentValue = changes.open && changes.open.currentValue;

    if (currentValue !== openPreviousValue && !changes.open.firstChange) {
      if (this.open) {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  }

  public ngOnDestroy(): void {
    this.closeModal();

    this.isDestroy$.next(true);
    this.isDestroy$.complete();
  }

  public openModal() {
    if (this.templateModal) {
      this.modalRef = this.modalService.show(this.templateModal, {
        class: [`modal-${this.size} modal-dialog-centered`, this.modalClass].join(' '),
        ignoreBackdropClick: true,
        keyboard: false,
      });
      this.changeDetectorRef.detectChanges();
    }
  }

  public closeModal() {
    if (this.modalRef && this.modalRef.hide) {
      this.modalRef.hide();
      this.changeDetectorRef.detectChanges();
    }
    this.openChange.emit(false);
  }
}
